// extracted by mini-css-extract-plugin
export default {"btop":"_2c302c8d51 _1d5e52074c ed8b6362a3","icon":"_3024b99828 _1db8bc2823","btoppink":"_54ab42af40 _63467371c3"};